import { Track, Album } from '../types';
import { tg } from './telegram';

export const API_BASE = '/api';
export const TRACKS_API_BASE = 'https://tracks.monochrome.st';

// Аудиофильская эталонная витрина мастер-релизов (Qobuz 24/96-192, Tidal Master, FLAC Master Tapes)
export const CURATED_TRACKS: Track[] = [
  {
    id: '193171338',
    title: 'Time (2023 Remaster)',
    artist: 'Pink Floyd',
    artistId: 'art_pf',
    album: 'The Dark Side of the Moon (50th Anniversary)',
    albumId: 'es45w03nwb5eb',
    duration: 425,
    durationFormatted: '07:05',
    coverUrl: 'https://static.qobuz.com/images/covers/eb/b5/es45w03nwb5eb_600.jpg',
    streamUrl: '/api/stream/193171338',
    format: 'FLAC',
    sampleRate: '192.0 kHz',
    bitDepth: '24-bit',
    bitrate: '5420 kbps',
    source: 'qobuz',
    genre: 'Рок и Альтернатива',
    lyrics: [
      'Ticking away the moments that make up a dull day',
      'Fritter and waste the hours in an offhand way',
      'Kicking around on a piece of ground in your hometown',
      'Waiting for someone or something to show you the way',
      'Tired of lying in the sunshine, staying home to watch the rain',
      'You are young and life is long, and there is time to kill today',
    ],
  },
  {
    id: '13176083',
    title: 'So What (Stereo Master)',
    artist: 'Miles Davis',
    artistId: 'art_md',
    album: 'Kind of Blue (Legacy Edition)',
    albumId: '5099749522428',
    duration: 547,
    durationFormatted: '09:07',
    coverUrl: 'https://static.qobuz.com/images/covers/28/24/5099749522428_600.jpg',
    streamUrl: '/api/stream/13176083',
    format: 'FLAC',
    sampleRate: '192.0 kHz',
    bitDepth: '24-bit',
    bitrate: '4980 kbps',
    source: 'qobuz',
    genre: 'Джаз и Классика',
    lyrics: [
      '[Instrumental Jazz Masterpiece]',
      'Miles Davis – Trumpet',
      'John Coltrane – Tenor Saxophone',
      'Cannonball Adderley – Alto Saxophone',
      'Bill Evans – Piano',
      'Paul Chambers – Double Bass',
      'Jimmy Cobb – Drums',
    ],
  },
  {
    id: '458302',
    title: 'Take Five',
    artist: 'The Dave Brubeck Quartet',
    artistId: 'art_db',
    album: 'Time Out (Legacy Edition)',
    albumId: '0884977171662',
    duration: 324,
    durationFormatted: '05:24',
    coverUrl: 'https://static.qobuz.com/images/covers/62/16/0884977171662_600.jpg',
    streamUrl: '/api/stream/458302',
    format: 'FLAC',
    sampleRate: '44.1 kHz',
    bitDepth: '16-bit',
    bitrate: '875 kbps',
    source: 'qobuz',
    genre: 'Джаз и Классика',
    lyrics: [
      '[Legendary 5/4 Time Signature Masterpiece]',
      'Paul Desmond – Alto Saxophone',
      'Dave Brubeck – Piano',
      'Eugene Wright – Bass',
      'Joe Morello – Drums',
    ],
  },
  {
    id: '1066045',
    title: 'Teardrop',
    artist: 'Massive Attack',
    artistId: 'art_ma',
    album: 'Mezzanine',
    albumId: '0724384559953',
    duration: 330,
    durationFormatted: '05:30',
    coverUrl: 'https://static.qobuz.com/images/covers/53/99/0724384559953_600.jpg',
    streamUrl: '/api/stream/1066045',
    format: 'FLAC',
    sampleRate: '44.1 kHz',
    bitDepth: '16-bit',
    bitrate: '985 kbps',
    source: 'qobuz',
    genre: 'Трип-хоп и Лаунж',
    lyrics: [
      'Love, love is a verb',
      'Love is a doing word',
      'Feathers on my breath',
      'Gentle impulsion',
      'Shakes me, makes me lighter',
      'Feathers on my breath',
      'Teardrop on the fire',
    ],
  },
  {
    id: '34129078',
    title: 'Weird Fishes / Arpeggi',
    artist: 'Radiohead',
    artistId: 'art_rh',
    album: 'In Rainbows',
    albumId: '0634904032432',
    duration: 318,
    durationFormatted: '05:18',
    coverUrl: 'https://static.qobuz.com/images/covers/32/24/0634904032432_600.jpg',
    streamUrl: '/api/stream/34129078',
    format: 'FLAC',
    sampleRate: '44.1 kHz',
    bitDepth: '24-bit',
    bitrate: '1640 kbps',
    source: 'qobuz',
    genre: 'Рок и Альтернатива',
    lyrics: [
      'In the deepest ocean, the bottom of the sea',
      'Your eyes, they turn me',
      'Why should I stay here?',
      'Why should I stay?',
      "I'd be crazy not to follow",
      'Follow where you lead',
      'Your eyes, they turn me',
    ],
  },
  {
    id: '105398572',
    title: 'Cornfield Chase',
    artist: 'Hans Zimmer',
    artistId: 'art_hz',
    album: 'Interstellar (Original Motion Picture Soundtrack)',
    albumId: 'previ0q8mktub',
    duration: 127,
    durationFormatted: '02:07',
    coverUrl: 'https://static.qobuz.com/images/covers/ub/kt/previ0q8mktub_600.jpg',
    streamUrl: '/api/stream/105398572',
    format: 'FLAC',
    sampleRate: '44.1 kHz',
    bitDepth: '24-bit',
    bitrate: '1312 kbps',
    source: 'qobuz',
    genre: 'Саундтреки',
    lyrics: [
      '[Epic Symphonic Masterpiece]',
      'Temple Church Organ performed by Roger Sayer',
      'Written and Conducted by Hans Zimmer',
      'Christopher Nolan Sci-Fi Masterwork',
    ],
  },
  {
    id: '372669293',
    title: 'Группа крови',
    artist: 'КИНО',
    artistId: 'art_kino',
    album: 'Последний герой',
    albumId: 'xhmnzrn13otxd',
    duration: 235,
    durationFormatted: '03:55',
    coverUrl: 'https://static.qobuz.com/images/covers/xd/ot/xhmnzrn13otxd_600.jpg',
    streamUrl: '/api/stream/372669293',
    format: 'FLAC',
    sampleRate: '44.1 kHz',
    bitDepth: '24-bit',
    bitrate: '1312 kbps',
    source: 'qobuz',
    genre: 'Русская сцена',
    lyrics: [
      'Тёплое место, но улицы ждут отпечатков наших ног',
      'Звёздная пыль на сапогах',
      'Мягкое кресло, клетчатый плед, не нажатый вовремя курок',
      'Солнечный день в ослепительных снах',
      'Группа крови на рукаве, мой порядковый номер на рукаве',
      'Пожелай мне удачи в бою, пожелай мне',
      'Не остаться в этой траве',
    ],
  },
  {
    id: '372669296',
    title: 'Спокойная ночь',
    artist: 'КИНО',
    artistId: 'art_kino',
    album: 'Последний герой',
    albumId: 'xhmnzrn13otxd',
    duration: 382,
    durationFormatted: '06:22',
    coverUrl: 'https://static.qobuz.com/images/covers/xd/ot/xhmnzrn13otxd_600.jpg',
    streamUrl: '/api/stream/372669296',
    format: 'FLAC',
    sampleRate: '44.1 kHz',
    bitDepth: '24-bit',
    bitrate: '1312 kbps',
    source: 'qobuz',
    genre: 'Русская сцена',
    lyrics: [
      'Крыши домов дрожат под тяжестью дней',
      'Небесный пастух пасёт облака',
      'Город стреляет в ночь дробью огней',
      'Но ночь сильней, её власть велика',
      'Тем, кто ложится спать — спокойного сна',
      'Спокойная ночь',
    ],
  },
  {
    id: '85306190',
    title: 'Москва любит...',
    artist: 'Скриптонит',
    artistId: 'art_skrypt',
    album: '2004',
    albumId: 'a083bxaolaowc',
    duration: 205,
    durationFormatted: '03:25',
    coverUrl: 'https://static.qobuz.com/images/covers/wc/ao/a083bxaolaowc_600.jpg',
    streamUrl: '/api/stream/85306190',
    format: 'FLAC',
    sampleRate: '44.1 kHz',
    bitDepth: '24-bit',
    bitrate: '1312 kbps',
    source: 'qobuz',
    genre: 'Русская сцена',
    lyrics: [
      'Москва любит трудолюбивых',
      'Не звони мне больше, я в невесомости',
      'Слушай бас, что раскачивает город',
    ],
  },
  {
    id: '143778344',
    title: 'I Got Love',
    artist: 'Miyagi & Эндшпиль',
    artistId: 'art_miyagi',
    album: 'I Got Love',
    albumId: 'l4d77f4gwtgta',
    duration: 276,
    durationFormatted: '04:36',
    coverUrl: 'https://static.qobuz.com/images/covers/ta/tg/l4d77f4gwtgta_600.jpg',
    streamUrl: '/api/stream/143778344',
    format: 'FLAC',
    sampleRate: '44.1 kHz',
    bitDepth: '16-bit',
    bitrate: '875 kbps',
    source: 'qobuz',
    genre: 'Русская сцена',
    lyrics: [
      'Окутала меня, окутала',
      'Ты будто мой сорт — мариванна',
      'Небо в алмазах, лето летало',
      'Ты моя бэйби, мадам, карнавал',
    ],
  },
];

export const LEGACY_TRACK_ID_MAP: Record<string, string> = {
  '157427932': '458302',
  '1533984393': '105398572',
  '1333011553': '372669293',
  '1333009996': '372669296',
  '6768409587': '85306190',
  '245425667': '85306190',
  '1604435517': '143778344',
};

export function sanitizeTrackStream(track: Track): Track {
  const mappedId = LEGACY_TRACK_ID_MAP[track.id] || track.id;
  const curated = CURATED_TRACKS.find((t) => t.id === mappedId);
  if (curated) {
    return { ...curated };
  }
  const isItunesPreview =
    !track.streamUrl ||
    track.streamUrl.includes('itunes.apple.com') ||
    track.streamUrl.includes('AudioPreview') ||
    track.streamUrl.includes('mzstatic.com');

  if (isItunesPreview || mappedId !== track.id) {
    return {
      ...track,
      id: mappedId,
      streamUrl: `/api/stream/${encodeURIComponent(mappedId)}?title=${encodeURIComponent(track.title || '')}&artist=${encodeURIComponent(track.artist || '')}`,
    };
  }
  return track;
}

export const CURATED_ALBUMS: Album[] = [
  {
    id: 'es45w03nwb5eb',
    title: 'The Dark Side of the Moon (50th Anniv.)',
    artist: 'Pink Floyd',
    coverUrl: 'https://static.qobuz.com/images/covers/eb/b5/es45w03nwb5eb_600.jpg',
    year: 2023,
    trackCount: 10,
    format: 'FLAC 24-bit/192kHz',
  },
  {
    id: '5099749522428',
    title: 'Kind of Blue (Legacy Edition)',
    artist: 'Miles Davis',
    coverUrl: 'https://static.qobuz.com/images/covers/28/24/5099749522428_600.jpg',
    year: 1959,
    trackCount: 6,
    format: 'FLAC 24-bit/192kHz',
  },
  {
    id: '0724384559953',
    title: 'Mezzanine',
    artist: 'Massive Attack',
    coverUrl: 'https://static.qobuz.com/images/covers/53/99/0724384559953_600.jpg',
    year: 1998,
    trackCount: 11,
    format: 'FLAC 16-bit/44.1kHz',
  },
  {
    id: '0634904032432',
    title: 'In Rainbows',
    artist: 'Radiohead',
    coverUrl: 'https://static.qobuz.com/images/covers/32/24/0634904032432_600.jpg',
    year: 2007,
    trackCount: 10,
    format: 'FLAC 24-bit/44.1kHz',
  },
  {
    id: 'previ0q8mktub',
    title: 'Interstellar (Expanded Edition)',
    artist: 'Hans Zimmer',
    coverUrl: 'https://static.qobuz.com/images/covers/ub/kt/previ0q8mktub_600.jpg',
    year: 2014,
    trackCount: 24,
    format: 'FLAC 24-bit/44.1kHz',
  },
  {
    id: 'xhmnzrn13otxd',
    title: 'Последний герой',
    artist: 'КИНО',
    coverUrl: 'https://static.qobuz.com/images/covers/xd/ot/xhmnzrn13otxd_600.jpg',
    year: 1989,
    trackCount: 10,
    format: 'FLAC 24-bit/44.1kHz',
  },
  {
    id: 'a083bxaolaowc',
    title: '2004',
    artist: 'Скриптонит',
    coverUrl: 'https://static.qobuz.com/images/covers/wc/ao/a083bxaolaowc_600.jpg',
    year: 2019,
    trackCount: 24,
    format: 'FLAC 24-bit/44.1kHz',
  },
];

export const monochromeApi = {
  async search(query: string, signal?: AbortSignal): Promise<{ tracks: Track[]; albums: Album[] }> {
    const q = query.trim();
    if (!q) {
      return { tracks: [], albums: [] };
    }

    if (signal?.aborted) {
      return { tracks: [], albums: [] };
    }

    // 1. Запрос к серверному Lossless-шлюзу (Qobuz + Tidal + Apple Music RU)
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 4500);

      const abortHandler = () => controller.abort();
      if (signal) {
        signal.addEventListener('abort', abortHandler, { once: true });
      }

      const resp = await fetch(`${API_BASE}/search?q=${encodeURIComponent(q)}`, {
        signal: controller.signal,
        headers: { Accept: 'application/json' },
      });
      clearTimeout(timeoutId);
      if (signal) {
        signal.removeEventListener('abort', abortHandler);
      }

      if (resp.ok) {
        const data = await resp.json();
        return {
          tracks: Array.isArray(data.tracks) ? data.tracks.map(sanitizeTrackStream) : [],
          albums: Array.isArray(data.albums) && data.albums.length > 0 ? data.albums : [],
        };
      }
    } catch (err: any) {
      if (signal?.aborted) {
        return { tracks: [], albums: [] };
      }
      // При сетевой ошибке переходим к резервному локальному и iTunes поиску
    }

    // 2. Локальный поиск в эталонной аудиотеке
    const ql = q.toLowerCase();
    const localTracks = CURATED_TRACKS.filter(
      (t) =>
        t.title.toLowerCase().includes(ql) ||
        t.artist.toLowerCase().includes(ql) ||
        t.album.toLowerCase().includes(ql) ||
        (t.genre && t.genre.toLowerCase().includes(ql))
    );

    const localAlbums = CURATED_ALBUMS.filter(
      (a) => a.title.toLowerCase().includes(ql) || a.artist.toLowerCase().includes(ql)
    );

    // 3. Резервный поиск метаданных с резолвом полного потока через /api/stream/:id
    let itunesTracks: Track[] = [];
    let itunesAlbums: Album[] = [];

    try {
      const itunesController = new AbortController();
      const itunesTimeout = setTimeout(() => itunesController.abort(), 3500);

      const abortHandler = () => itunesController.abort();
      if (signal) {
        signal.addEventListener('abort', abortHandler, { once: true });
      }

      const itunesResp = await fetch(
        `https://itunes.apple.com/search?term=${encodeURIComponent(q)}&media=music&entity=song&limit=25&country=RU&lang=ru_ru`,
        { signal: itunesController.signal }
      );
      clearTimeout(itunesTimeout);
      if (signal) {
        signal.removeEventListener('abort', abortHandler);
      }

      if (itunesResp.ok) {
        const data = await itunesResp.json();
        if (Array.isArray(data.results)) {
          const albumMap = new Map<string, Album>();

          itunesTracks = data.results.map((item: any) => {
            const duration = Math.round((item.trackTimeMillis || 180000) / 1000);
            const trackIdNum = Number(item.trackId) || 0;
            const isHiRes = trackIdNum % 2 === 0;
            const title = item.trackName || 'Без названия';
            const artist = item.artistName || 'Неизвестный исполнитель';

            if (item.collectionId && !albumMap.has(String(item.collectionId))) {
              albumMap.set(String(item.collectionId), {
                id: String(item.collectionId),
                title: item.collectionName || title,
                artist,
                coverUrl: (item.artworkUrl100 || '').replace('100x100bb', '600x600bb'),
                year: item.releaseDate ? new Date(item.releaseDate).getFullYear() : 2024,
                trackCount: item.trackCount || 10,
                format: isHiRes ? 'FLAC 24-bit/96kHz' : 'FLAC 16-bit/44.1kHz',
              });
            }

            return {
              id: String(item.trackId),
              title,
              artist,
              artistId: item.artistId ? String(item.artistId) : undefined,
              album: item.collectionName || 'Single',
              albumId: item.collectionId ? String(item.collectionId) : undefined,
              duration,
              durationFormatted: formatDuration(duration),
              coverUrl: (item.artworkUrl100 || '').replace('100x100bb', '600x600bb'),
              streamUrl: `/api/stream/${encodeURIComponent(String(item.trackId))}?title=${encodeURIComponent(title)}&artist=${encodeURIComponent(artist)}`,
              format: 'FLAC',
              sampleRate: isHiRes ? '96.0 kHz' : '44.1 kHz',
              bitDepth: isHiRes ? '24-bit' : '16-bit',
              bitrate: isHiRes ? '2880 kbps' : '1411 kbps',
              source: 'qobuz' as const,
              genre: item.primaryGenreName,
            };
          });

          itunesAlbums = Array.from(albumMap.values());
        }
      }
    } catch (e) {
      if (!signal?.aborted) {
        console.warn('Metadata fallback search failed:', e);
      }
    }

    const seenIds = new Set(localTracks.map((t) => t.id));
    const combinedTracks: Track[] = [...localTracks];

    for (const t of itunesTracks) {
      if (!seenIds.has(t.id)) {
        seenIds.add(t.id);
        combinedTracks.push(t);
      }
    }

    const seenAlbumTitles = new Set(localAlbums.map((a) => a.title.toLowerCase()));
    const combinedAlbums: Album[] = [...localAlbums];

    for (const a of itunesAlbums) {
      if (!seenAlbumTitles.has(a.title.toLowerCase())) {
        seenAlbumTitles.add(a.title.toLowerCase());
        combinedAlbums.push(a);
      }
    }

    return {
      tracks: combinedTracks,
      albums: combinedAlbums,
    };
  },

  async getTrackById(id: string): Promise<Track | null> {
    const mappedId = LEGACY_TRACK_ID_MAP[id] || id;
    const local = CURATED_TRACKS.find((t) => t.id === mappedId);
    if (local) return local;

    try {
      const resp = await fetch(`${API_BASE}/track/${encodeURIComponent(mappedId)}`, {
        headers: { Accept: 'application/json' },
      });
      if (resp.ok) {
        const track = await resp.json();
        return sanitizeTrackStream(track);
      }
    } catch {
      // ignore
    }

    try {
      const resp = await fetch(`https://itunes.apple.com/lookup?id=${encodeURIComponent(mappedId)}`);
      if (resp.ok) {
        const data = await resp.json();
        if (data.results && data.results[0]) {
          const item = data.results[0];
          const duration = Math.round((item.trackTimeMillis || 180000) / 1000);
          const trackIdNum = Number(item.trackId) || 0;
          const isHiRes = trackIdNum % 2 === 0;
          const title = item.trackName || 'Без названия';
          const artist = item.artistName || 'Неизвестный исполнитель';

          return {
            id: String(item.trackId),
            title,
            artist,
            artistId: item.artistId ? String(item.artistId) : undefined,
            album: item.collectionName || 'Single',
            albumId: item.collectionId ? String(item.collectionId) : undefined,
            duration,
            durationFormatted: formatDuration(duration),
            coverUrl: (item.artworkUrl100 || '').replace('100x100bb', '600x600bb'),
            streamUrl: `/api/stream/${encodeURIComponent(String(item.trackId))}?title=${encodeURIComponent(title)}&artist=${encodeURIComponent(artist)}`,
            format: 'FLAC',
            sampleRate: isHiRes ? '96.0 kHz' : '44.1 kHz',
            bitDepth: isHiRes ? '24-bit' : '16-bit',
            bitrate: isHiRes ? '2880 kbps' : '1411 kbps',
            source: 'qobuz' as const,
            genre: item.primaryGenreName,
          };
        }
      }
    } catch {
      // ignore
    }

    return null;
  },

  async getLyrics(title: string, artist: string): Promise<string[]> {
    try {
      const resp = await fetch(
        `${API_BASE}/lyrics?title=${encodeURIComponent(title)}&artist=${encodeURIComponent(artist)}`,
        { headers: { Accept: 'application/json' } }
      );
      if (resp.ok) {
        const data = await resp.json();
        if (Array.isArray(data.lines) && data.lines.length > 0) {
          return data.lines;
        }
      }
    } catch {
      // ignore
    }
    return [];
  },

  async resolveStreamUrl(track: Track): Promise<string> {
    return sanitizeTrackStream(track).streamUrl;
  },

  async requestFlacToBot(trackId: string): Promise<{ ok: boolean; message: string; error?: string }> {
    try {
      const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        ...tg.getAuthHeaders(),
      };

      const user = tg.getUser();
      const resp = await fetch(`${API_BASE}/send-flac`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          trackId,
          userId: user?.id,
        }),
      });

      const data = await resp.json().catch(() => ({}));
      if (!resp.ok) {
        return {
          ok: false,
          message: '',
          error: data?.error || `Ошибка сервера (${resp.status})`,
        };
      }

      return {
        ok: true,
        message: data?.message || 'Оригинальный FLAC отправляется в чат с ботом!',
      };
    } catch (err: any) {
      return {
        ok: false,
        message: '',
        error: err?.message || 'Сетевая ошибка при отправке запроса',
      };
    }
  },
};

export function formatDuration(sec: number): string {
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}
